<template>
  <scroll-layout>
    <template slot="header">
      <div v-if="pageButtons.length > 0" class="button-wrap">
        <ykc-button
          v-for="(button, index) in pageButtons"
          :key="button.id || index"
          v-bind="button"
          @click="button.handleClick(button, $event)">
          {{ button.text }}
        </ykc-button>
      </div>
    </template>
    <div class="fleet-match-content">
      <YkcDetailPlus class="box-card" :labelWidth="150">
        <div slot="header" class="clearfix">
          <span>【订单信息】</span>
        </div>
        <div style="display: flex; padding: 10px; justify-content: space-between; width: 100%">
          <YkcDetailItemPlus label="订单id:">
            {{ dealData(detail.mainInfo?.id) }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="订单类型:">
            {{ getOrderTypeText(detail.mainInfo?.orderType) }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="订单交易额模式:">
            {{ getTradeModeText(detail.mainInfo?.tradeMode) }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="订单来源渠道:">
            {{ detail.mainInfo?.sourceChannel || '——' }}
          </YkcDetailItemPlus>
        </div>
        <div style="display: flex; padding: 10px; justify-content: space-between; width: 100%">
          <YkcDetailItemPlus label="开始充电时间:">
            {{ dealData(detail.mainInfo?.startTime) }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="结束充电时间:">
            {{ dealData(detail.mainInfo?.endTime) }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="充电时长:">
            {{
              detail.mainInfo?.chargingDuration ? detail.mainInfo?.chargingDuration + '小时' : '——'
            }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="充电电量:">
            {{ detail.mainInfo?.chargingPower ? detail.mainInfo?.chargingPower + '度' : '——' }}
          </YkcDetailItemPlus>
        </div>
        <div style="display: flex; padding: 10px; justify-content: space-between; width: 100%">
          <YkcDetailItemPlus label="电费（不含优惠）:">
            {{ dealData(detail.mainInfo?.electricityFee) }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="服务费（不含优惠）:">
            {{ dealData(detail.mainInfo?.serviceFee) }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="优惠总金额:">
            {{ detail.mainInfo?.totalDiscount ? detail.mainInfo?.totalDiscount + '元' : '——' }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="运费:">
            {{ detail.mainInfo?.shippingFee || '——' }}
          </YkcDetailItemPlus>
        </div>
        <div style="display: flex; padding: 10px; justify-content: space-between; width: 100%">
          <YkcDetailItemPlus label="订单实付总金额:">
            {{ detail.mainInfo?.totalMeetAmount ? detail.mainInfo?.totalMeetAmount + '元' : '——' }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="订单金额是否给物业:">
            {{
              detail.mainInfo?.amountToProperty == 1
                ? '是'
                : detail.mainInfo?.amountToProperty == 0
                ? '否'
                : '——'
            }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="订单支付状态:">
            {{ getPaymentStatusText(detail.mainInfo?.paymentStatus) }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="用户备注:">
            {{ detail.mainInfo?.userRemark || '——' }}
          </YkcDetailItemPlus>
        </div>
        <div style="display: flex; padding: 10px; justify-content: space-between; width: 100%">
          <YkcDetailItemPlus label="下单方式:">
            {{ getOrderMethodText(detail.mainInfo?.orderMethod) }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="发货时间:">
            {{ detail.mainInfo?.shippingTime || '——' }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="完成时间:">
            {{ detail.mainInfo?.completionTime || '——' }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="支付时间:">
            {{ detail.mainInfo?.paymentTime || '——' }}
          </YkcDetailItemPlus>
        </div>
        <div style="display: flex; padding: 10px; justify-content: space-between; width: 50%">
          <YkcDetailItemPlus label="创建时间:">
            {{ dealData(detail.mainInfo?.createdTime) || '——' }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="更新时间:">
            {{ dealData(detail.mainInfo?.modifiedTime) || '——' }}
          </YkcDetailItemPlus>
        </div>
      </YkcDetailPlus>
    </div>
    <div class="fleet-match-content">
      <YkcDetailPlus class="box-card" :labelWidth="150">
        <div slot="header" class="clearfix">
          <span>【用户信息】</span>
        </div>
        <div style="display: flex; padding: 10px; justify-content: space-between; width: 100%">
          <YkcDetailItemPlus label="用户id:">
            {{ dealData(detail.mainInfo?.userId) }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="用户等级:">
            {{ getUserLevelText(detail.mainInfo?.userLevel) }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="用户成长值:">
            {{ detail.mainInfo?.userGrowthValue || '——' }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="用户手机号:">
            {{ detail.mainInfo?.userAccount || '——' }}
          </YkcDetailItemPlus>
        </div>
      </YkcDetailPlus>
    </div>
    <div class="fleet-match-center">
      <YkcDetailPlus class="box-card-prop-left" :labelWidth="150">
        <div slot="header" class="clearfix">
          <span>商品列表信息</span>
        </div>
        <ykc-card
          style="
            height: 100%;
            display: flex;
            border: 1px solid #6e6e6e;
            min-width: 30%;
            max-width: 35%;
            flex-direction: column;
          ">
          <div style="padding: 10px; justify-content: space-between; width: 100%">
            <YkcDetailItemPlus label="商品名称:">
              {{ dealData(detail.productInfo?.productName) }}
            </YkcDetailItemPlus>
            <YkcDetailItemPlus label="商品id:">
              {{ dealData(detail.productInfo?.productId) }}
            </YkcDetailItemPlus>
            <YkcDetailItemPlus label="商品类型:">
              {{ getProductTypeText(detail.productInfo?.productType) }}
            </YkcDetailItemPlus>
            <YkcDetailItemPlus label="商品单位:">
              {{ detail.productInfo?.productUnit || '——' }}
            </YkcDetailItemPlus>
            <YkcDetailItemPlus label="商品单价:">
              {{ detail.productInfo?.unitPrice || '——' }}
            </YkcDetailItemPlus>
            <YkcDetailItemPlus label="购买数量:">
              {{ detail.productInfo?.purchaseQuantity || '——' }}
            </YkcDetailItemPlus>
            <YkcDetailItemPlus label="商品小计金额:">
              {{
                detail.productInfo?.subtotalAmount
                  ? detail.productInfo?.subtotalAmount + '元'
                  : '——'
              }}
            </YkcDetailItemPlus>
          </div>
        </ykc-card>
      </YkcDetailPlus>
      <YkcDetailPlus class="box-card-prop-right" :labelWidth="150">
        <div slot="header" class="clearfix">
          <span>商户信息</span>
        </div>
        <div style="padding: 10px; justify-content: space-between; width: 100%">
          <YkcDetailItemPlus label="商户ID:">
            {{ dealData(detail.mainInfo?.merchantId) }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="商户名称:">
            {{ dealData(detail.mainInfo?.merchantName) }}
          </YkcDetailItemPlus>
        </div>
        <div style="padding: 10px; justify-content: space-between; width: 100%">
          <YkcDetailItemPlus label="电桩ID:">
            {{ dealData(detail.mainInfo?.pileId) }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="终端ID:">
            {{ dealData(detail.mainInfo?.gunId) }}
          </YkcDetailItemPlus>
        </div>
        <div style="padding: 10px; justify-content: space-between; width: 100%">
          <YkcDetailItemPlus label="所属BD:">
            {{ dealData(detail.mainInfo?.stationBd) }}
          </YkcDetailItemPlus>
        </div>
        <div style="padding: 10px; justify-content: space-between; width: 100%">
          <YkcDetailItemPlus label="归属商户:">
            {{ dealData(detail.mainInfo?.mchCode) }}
          </YkcDetailItemPlus>
        </div>
        <div style="padding: 10px; justify-content: space-between; width: 100%">
          <YkcDetailItemPlus label="所属地区:">
            {{
              dealData(
                detail.mainInfo?.provinceName +
                  '-' +
                  detail.mainInfo?.cityName +
                  '-' +
                  detail.mainInfo?.districtName
              )
            }}
          </YkcDetailItemPlus>
        </div>
      </YkcDetailPlus>
    </div>
    <div class="fleet-match-center">
      <YkcDetailPlus class="box-card-prop-left" :labelWidth="150">
        <div slot="header" class="clearfix">
          <span>
            营销优惠信息————优惠总金额（
            <span class="blue-text">{{ calculateTotalPromotionAmount().total }}</span>
            元）= 电费优惠总金额（
            <span class="blue-text">{{ calculateTotalPromotionAmount().electricity }}</span>
            元）+ 服务费优惠总金额（
            <span class="blue-text">{{ calculateTotalPromotionAmount().service }}</span>
            元）
          </span>
        </div>
        <div
          v-if="detail.promotionInfos && detail.promotionInfos.length > 0"
          style="
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            justify-content: space-between;
            gap: 10px;
          ">
          <ykc-card
            v-for="(promotion, index) in detail.promotionInfos"
            :key="index"
            style="
              flex: none;
              min-width: 32%;
              max-width: 40%;
              height: fit-content;
              display: flex;
              border: 1px solid #6e6e6e;
              box-sizing: border-box;
              padding: 10px;
            ">
            <div style="display: flex; flex-direction: column">
              <YkcDetailItemPlus label="优惠类型:">
                {{ getPromotionTypeText(promotion.promotionType) || '——' }}
              </YkcDetailItemPlus>
              <YkcDetailItemPlus label="优惠活动ID:">
                {{ promotion.promotionActivityId || '——' }}
              </YkcDetailItemPlus>
              <YkcDetailItemPlus label="优惠总金额:">
                {{ promotion.totalDiscountAmount ? promotion.totalDiscountAmount + '元' : '——' }}
              </YkcDetailItemPlus>
              <YkcDetailItemPlus label="电费优惠金额:">
                {{
                  promotion.electricityDiscountAmount
                    ? promotion.electricityDiscountAmount + '元'
                    : '——'
                }}
              </YkcDetailItemPlus>
              <YkcDetailItemPlus label="服务费优惠金额:">
                {{
                  promotion.serviceFeeDiscountAmount
                    ? promotion.serviceFeeDiscountAmount + '元'
                    : '——'
                }}
              </YkcDetailItemPlus>
            </div>
          </ykc-card>
        </div>
      </YkcDetailPlus>
      <YkcDetailPlus class="box-card-prop-right" :labelWidth="150">
        <div slot="header" class="clearfix">
          <span>支付信息</span>
        </div>
        <div style="padding: 10px; justify-content: space-between; width: 100%">
          <YkcDetailItemPlus label="支付方式:">
            {{ getPayMethodText(detail.paymentInfo?.payMethod) }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="支付状态:">
            {{ getPayStatusText(detail.paymentInfo?.payStatus) }}
          </YkcDetailItemPlus>
        </div>
        <div style="padding: 10px; justify-content: space-between; width: 100%">
          <YkcDetailItemPlus label="支付金额:">
            {{ detail.paymentInfo?.payAmount ? detail.paymentInfo?.payAmount + '元' : '——' }}
          </YkcDetailItemPlus>
        </div>
        <div style="padding: 10px; justify-content: space-between; width: 100%">
          <YkcDetailItemPlus label="支付时间:">
            {{ detail.paymentInfo?.payTime || '——' }}
          </YkcDetailItemPlus>
        </div>
        <div style="padding: 10px; justify-content: space-between; width: 100%">
          <YkcDetailItemPlus label="收款商户号:">
            {{ detail.paymentInfo?.merchantId || '——' }}
          </YkcDetailItemPlus>
        </div>
        <div style="padding: 10px; justify-content: space-between; width: 100%">
          <YkcDetailItemPlus label="支付流水号:">
            {{ detail.paymentInfo?.transactionNo || '——' }}
          </YkcDetailItemPlus>
        </div>
      </YkcDetailPlus>
    </div>
    <div v-if="detail.refundInfo" class="fleet-match-content">
      <YkcDetailPlus class="box-card" :labelWidth="150">
        <div slot="header" class="clearfix">
          <span>退款信息</span>
        </div>
        <div style="display: flex; padding: 10px; width: 100%">
          <YkcDetailItemPlus label="退款单ID:">
            {{ dealData(detail.refundInfo?.orderId) }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="申请人类型:">
            {{ getApplicantTypeText(detail.refundInfo?.applicantType) }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="申请人ID:">
            {{ detail.refundInfo?.applicantId }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="退款申请备注:" vAlign="flex-start">
            {{ dealData(detail.refundInfo?.refundRemark) }}
          </YkcDetailItemPlus>
        </div>
        <div style="display: flex; padding: 10px; justify-content: space-between; width: 100%">
          <YkcDetailItemPlus label="退款原因:">
            {{ dealData(detail.refundInfo?.refundReason) }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="退款类型:">
            {{ getRefundTypeText(detail.refundInfo?.refundType) }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="退款金额:">
            {{ detail.refundInfo?.refundAmount ? detail.refundInfo?.refundAmount + '元' : '——' }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="退款状态:">
            {{ getRefundStatusText(detail.refundInfo?.refundStatus) }}
          </YkcDetailItemPlus>
        </div>
        <div style="display: flex; padding: 10px; justify-content: space-between; width: 100%">
          <YkcDetailItemPlus label="退款回执单号:">
            {{ dealData(detail.refundInfo?.refundReceiptNo) }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="退款失败原因:">
            {{ detail.refundInfo?.refundFailReason }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="退款成功时间:">
            {{ dealData(detail.refundInfo?.refundSuccessTime) }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="审核人:">
            {{ dealData(detail.refundInfo?.reviewer) }}
          </YkcDetailItemPlus>
        </div>
        <div style="display: flex; padding: 10px; justify-content: space-between; width: 100%">
          <YkcDetailItemPlus label="审核备注:">
            {{ dealData(detail.refundInfo?.reviewRemark) }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="审核时间:">
            {{ dealData(detail.refundInfo?.reviewTime) }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="退款商户名称:">
            {{ detail.refundInfo?.refundMerchantName }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="退款商户号:">
            {{ dealData(detail.refundInfo?.refundMerchantCode) }}
          </YkcDetailItemPlus>
        </div>
        <div style="display: flex; padding: 10px; justify-content: space-between; width: 100%">
          <YkcDetailItemPlus label="用户账户:">
            {{ dealData(detail.refundInfo?.userAccount) }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="银行卡号:">
            {{ dealData(detail.refundInfo?.bankCardNumber) }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="开户行:">
            {{ dealData(detail.refundInfo?.bankName) }}
          </YkcDetailItemPlus>
          <YkcDetailItemPlus label="退款创建时间:">
            {{ detail.refundInfo?.createdTime }}
          </YkcDetailItemPlus>
        </div>
        <div style="display: flex; padding: 10px; justify-content: space-between; width: 100%">
          <YkcDetailItemPlus label="退款更新时间:">
            {{ dealData(detail.refundInfo?.modifiedTime) }}
          </YkcDetailItemPlus>
        </div>
      </YkcDetailPlus>
    </div>
  </scroll-layout>
</template>

<script>
  import { businessPlatform } from '@/service/apis';

  export default {
    components: {},
    name: 'orderDataDetail',
    data() {
      return {
        detail: {},
        pageInfo: {
          total: 0,
          pageSize: 10,
          currentPage: 1,
        },
        pageButtons: [
          {
            id: '1',
            text: '返回',
            type: 'plain',
            handleClick: () => {
              this.$router.go(-1);
            },
          },
        ],
      };
    },

    created() {
      this.getDetail();
    },
    methods: {
      getDetail() {
        console.log('queryId', this.$route.query.orderId);
        const queryId = this.$route.query.orderId;
        businessPlatform.getOrderDataDetail({ orderId: queryId }).then(res => {
          this.detail = res;
          console.log('res', res);
        });
      },

      /**
       * 获取价格编辑历史记录（带分页）
       */
      getPriceEditHistory() {
        const { stationId } = this.$route.query;
        const params = {
          stationId,
          current: this.pageInfo.currentPage,
          size: this.pageInfo.pageSize,
        };

        businessPlatform.history(params).then(res => {
          console.log('history res', res);
          this.priceEditRecord = res.records || [];
          this.pageInfo.total = res.total || 0;
        });
      },

      /**
       * 处理页码变化
       */
      handlePageChange(currentPage) {
        this.pageInfo.currentPage = currentPage;
        this.getPriceEditHistory();
      },

      /**
       * 处理页面大小变化
       */
      handleSizeChange(pageSize) {
        this.pageInfo.pageSize = pageSize;
        this.pageInfo.currentPage = 1; // 重置到第一页
        this.getPriceEditHistory();
      },
      dealData(data, append) {
        const label = append ? `${data + append}` : data;
        return label || '——';
      },
      getPaymentStatusText(status) {
        if (status === undefined || status === null) {
          return '——';
        }

        const statusMap = {
          1: '待支付',
          2: '已支付',
        };

        return statusMap[status] || status; // 如果状态码不在映射中，返回原始值
      },

      getOrderMethodText(orderMethod) {
        if (orderMethod === undefined || orderMethod === null) {
          return '——';
        }

        const orderMethodMap = {
          1: '扫码启动',
          3: '刷卡启动',
          4: '即插即充',
          5: '流量方',
          6: '预约充电',
          7: '离线卡',
          8: '私桩即插即充',
          9: '私桩预约充电',
        };

        return orderMethodMap[orderMethod] || orderMethod;
      },

      getPromotionTypeText(promotionType) {
        if (promotionType === undefined || promotionType === null) {
          return '——';
        }

        const promotionTypeMap = {
          1: '平台价格活动优惠',
          2: '商户价格活动优惠',
          3: '平台抵用卡优惠',
          4: '商户抵用卡优惠',
          5: '淘淘充平台优惠券抵扣',
          6: '淘淘充商户优惠券抵扣',
          7: '会员权益卡',
          8: 'VIP会员卡',
          9: '私桩红包',
          10: '会员等级折扣',
          11: '益虫促销卡',
          12: '益虫优惠券',
        };

        return promotionTypeMap[promotionType] || promotionType; // 如果类型码不在映射中，返回原始值
      },

      calculateTotalPromotionAmount() {
        if (!this.detail.promotionInfos || this.detail.promotionInfos.length === 0) {
          return { total: 0, electricity: 0, service: 0 };
        }

        let totalDiscount = 0;
        let electricityDiscount = 0;
        let serviceFeeDiscount = 0;

        this.detail.promotionInfos.forEach(promotion => {
          // 累加优惠总金额
          const totalAmount = parseFloat(promotion.totalDiscountAmount) || 0;
          totalDiscount += totalAmount;

          // 累加电费优惠金额
          const elecAmount = parseFloat(promotion.electricityDiscountAmount) || 0;
          electricityDiscount += elecAmount;

          // 累加服务费优惠金额
          const serviceAmount = parseFloat(promotion.serviceFeeDiscountAmount) || 0;
          serviceFeeDiscount += serviceAmount;
        });

        return {
          total: totalDiscount.toFixed(2),
          electricity: electricityDiscount.toFixed(2),
          service: serviceFeeDiscount.toFixed(2),
        };
      },

      getPayMethodText(payMethod) {
        if (payMethod === undefined || payMethod === null) {
          return '——';
        }

        const payMethodMap = {
          0: '个人',
          1: '企业',
          2: '微信支付分',
          3: '支付宝芝麻信用',
          4: '微信',
          5: '支付宝',
          6: '会员权益卡',
        };

        return payMethodMap[payMethod] || payMethod; // 如果支付方式码不在映射中，返回原始值
      },

      getPayStatusText(payStatus) {
        if (payStatus === undefined || payStatus === null) {
          return '——';
        }

        const payStatusMap = {
          1: '待支付',
          2: '支付成功',
          3: '支付失败',
          4: '已退款',
        };

        return payStatusMap[payStatus] || payStatus; // 如果支付状态码不在映射中，返回原始值
      },

      getProductTypeText(productType) {
        if (productType === undefined || productType === null) {
          return '——';
        }

        const productTypeMap = {
          1: '充电服务',
          2: '虚拟商品',
          3: '附加服务',
        };

        return productTypeMap[productType] || productType; // 如果商品类型码不在映射中，返回原始值
      },

      getRefundStatusText(refundStatus) {
        if (refundStatus === undefined || refundStatus === null) {
          return '——';
        }

        const refundStatusMap = {
          1: '审核中',
          2: '审核通过',
          3: '审核驳回',
          4: '退款中',
          5: '退款失败',
          6: '退款成功',
        };

        return refundStatusMap[refundStatus] || refundStatus; // 如果退款状态码不在映射中，返回原始值
      },

      getRefundTypeText(refundType) {
        if (refundType === undefined || refundType === null) {
          return '——';
        }

        const refundTypeMap = {
          1: '原路退回',
          2: '线下打款',
        };

        return refundTypeMap[refundType] || refundType; // 如果退款类型码不在映射中，返回原始值
      },

      getApplicantTypeText(applicantType) {
        if (applicantType === undefined || applicantType === null) {
          return '——';
        }

        const applicantTypeMap = {
          1: '用户',
          2: '商户',
          3: '平台',
        };

        return applicantTypeMap[applicantType] || applicantType; // 如果申请人类型码不在映射中，返回原始值
      },

      getUserLevelText(userLevel) {
        if (userLevel === undefined || userLevel === null) {
          return '——';
        }

        const userLevelMap = {
          1: '青铜会员',
          2: '白银会员',
          3: '黄金会员',
          4: '铂金会员',
          5: '星耀会员',
        };

        return userLevelMap[userLevel] || userLevel; // 如果用户等级码不在映射中，返回原始值
      },

      getOrderTypeText(orderType) {
        if (orderType === undefined || orderType === null) {
          return '——';
        }

        const orderTypeMap = {
          1: '淘淘充充电订单',
          2: '益虫充电订单',
        };

        return orderTypeMap[orderType] || orderType; // 如果订单类型码不在映射中，返回原始值
      },

      getTradeModeText(tradeMode) {
        if (tradeMode === undefined || tradeMode === null) {
          return '——';
        }

        const tradeModeMap = {
          1: '自营',
          2: '加盟',
        };

        return tradeModeMap[tradeMode] || tradeMode; // 如果交易额模式码不在映射中，返回原始值
      },
    },
  };
</script>
<style lang="scss" scoped>
  .fleet-match-content {
    display: flex;
    flex-flow: column;
    padding: 10px;
    .box-card {
      .title {
        color: inherit;
      }
      .ellipsis {
        width: 500px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
  .fleet-match-center {
    padding: 0 10px 10px;
    display: flex;
    flex-flow: row;
    .box-card-prop-right {
      width: 32.9%;
      padding: 10px;
      margin-right: 10px;
    }
    .box-card-prop-left {
      width: 65.9%;
      padding: 10px;
      margin-right: 10px;
    }
  }
  table {
    width: 100%;
    border-left: 1px solid #ccc;
    border-top: 1px solid #ccc;
    th {
      height: 44px;
    }
    td {
      height: 40px;
    }
    th,
    td {
      border-bottom: 1px solid #ccc;
      border-right: 1px solid #ccc;
    }
  }
  .blue-text {
    color: blue;
  }
</style>
